export default __webpack_public_path__ + "img/btn-lock.617f9a35.svg";